var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZeromewhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5896 20.4383C22.368 18.7626 22.8237 16.9218 22.9259 15.0346C23.035 13.0192 22.738 11.002 22.0568 9.13179C21.3757 7.26154 20.3277 5.58578 18.99 4.22791C17.6523 2.87003 16.059 1.86462 14.3275 1.28571C12.5959 0.7068 10.7702 0.569128 8.98469 0.882834C7.1992 1.19654 5.49943 1.95363 4.01054 3.09837C2.52165 4.24311 1.28157 5.74633 0.381592 7.49735L4.14389 9.91053C4.7208 8.78807 5.51573 7.82446 6.47015 7.09065C7.42457 6.35685 8.51418 5.87153 9.65873 5.67043C10.8033 5.46934 11.9736 5.55759 13.0836 5.92869C14.1936 6.29979 15.2149 6.94428 16.0724 7.81472C16.9299 8.68516 17.6017 9.75937 18.0383 10.9583C18.475 12.1571 18.6654 13.4502 18.5954 14.7421C18.5255 16.0341 18.1971 17.2921 17.6343 18.4234C17.2632 19.1695 16.7965 19.848 16.2506 20.4383H21.5896Z",
    fill: "url(#paint0_linear_4556_12258)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8894 21.3405C14.4048 21.3405 17.2547 18.1569 17.2547 14.2298C17.2547 10.3026 14.4048 7.11903 10.8894 7.11903C7.37399 7.11903 4.52417 10.3026 4.52417 14.2298C4.52417 18.1569 7.37399 21.3405 10.8894 21.3405ZM7.56654 18.9986C7.56654 18.9986 7.55433 15.6078 8.89269 14.3262C9.69538 13.5576 10.6096 13.3467 11.5417 13.1318C12.5167 12.9069 13.5112 12.6776 14.4183 11.8006C14.8259 11.4065 15.1406 10.8321 15.2623 10.6099C15.2797 10.5781 15.2932 10.5536 15.3024 10.5378C16.2453 12.2072 16.5327 16.4972 14.4183 18.6068C12.4161 20.6045 9.42626 20.1371 7.56654 18.9986Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4556_12258",
    x1: 18.6295,
    y1: 5.17801,
    x2: 3.24136,
    y2: 6.38967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeromewhite);
export default __webpack_public_path__ + "static/media/zeromewhite.c405b2bfa675db89503f4c29198cf4eb.svg";
export { ForwardRef as ReactComponent };